import type { JSX } from 'react';

type SoundIconProps = {
  className?: string;
  variant: 'off' | 'on';
};

const SoundIcon = (props: SoundIconProps): JSX.Element => {
  const { className, variant } = props;
  if (variant === 'on') {
    return (
      <svg
        className={className || ''}
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.65"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 3.6665C9.18848 3.6665 3.66666 9.18833 3.66666 15.9998C3.66666 22.8113 9.18848 28.3332 16 28.3332C22.8115 28.3332 28.3333 22.8113 28.3333 15.9998C28.3333 9.18833 22.8115 3.6665 16 3.6665ZM1.66666 15.9998C1.66666 8.08376 8.08391 1.6665 16 1.6665C23.9161 1.6665 30.3333 8.08376 30.3333 15.9998C30.3333 23.9159 23.9161 30.3332 16 30.3332C8.08391 30.3332 1.66666 23.9159 1.66666 15.9998Z"
          fill="white"
        />
        <path
          opacity="0.65"
          d="M15.1666 10.6665L11 13.9998H7.66663V18.9998H11L15.1666 22.3332V10.6665Z"
          stroke="white"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.65"
          d="M21.8916 10.6084C23.4539 12.1711 24.3315 14.2904 24.3315 16.5001C24.3315 18.7098 23.4539 20.829 21.8916 22.3917M18.95 13.5501C19.7311 14.3314 20.1699 15.391 20.1699 16.4959C20.1699 17.6007 19.7311 18.6604 18.95 19.4417"
          stroke="white"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
  if (variant === 'off') {
    return (
      <svg
        className={className || ''}
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.65"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 3.6665C9.18848 3.6665 3.66666 9.18833 3.66666 15.9998C3.66666 22.8113 9.18848 28.3332 16 28.3332C22.8115 28.3332 28.3333 22.8113 28.3333 15.9998C28.3333 9.18833 22.8115 3.6665 16 3.6665ZM1.66666 15.9998C1.66666 8.08376 8.08391 1.6665 16 1.6665C23.9161 1.6665 30.3333 8.08376 30.3333 15.9998C30.3333 23.9159 23.9161 30.3332 16 30.3332C8.08391 30.3332 1.66666 23.9159 1.66666 15.9998Z"
          fill="white"
        />
        <path
          opacity="0.65"
          d="M15.1666 10.6665L11 13.9998H7.66663V18.9998H11L15.1666 22.3332V10.6665Z"
          stroke="white"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.65"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.7323 14.5659C25.0447 14.2535 25.0447 13.7469 24.7323 13.4345C24.4199 13.1221 23.9134 13.1221 23.601 13.4345L21.6666 15.3688L19.7323 13.4345C19.4199 13.1221 18.9134 13.1221 18.601 13.4345C18.2885 13.7469 18.2885 14.2535 18.601 14.5659L20.5353 16.5002L18.601 18.4345C18.2885 18.7469 18.2885 19.2535 18.601 19.5659C18.9134 19.8783 19.4199 19.8783 19.7323 19.5659L21.6666 17.6316L23.601 19.5659C23.9134 19.8783 24.4199 19.8783 24.7323 19.5659C25.0447 19.2535 25.0447 18.7469 24.7323 18.4345L22.798 16.5002L24.7323 14.5659Z"
          fill="white"
        />
      </svg>
    );
  }
  return <></>;
};
export default SoundIcon;
